"use client"

import BaseFormProvider from '../../../../shared/components/forms/base-form-provider'
import React, { PropsWithChildren }  from 'react'
import { resetPassword } from '@/features/auth/api/auth.api'
import { PAGE_ROUTES } from '../../../../shared/constants/pages-routes'
import { useRouter } from 'next/navigation'
import { resetPasswordFormSchema, ResetPasswordFormType } from '../../schemas/reset-password.schema'
import errorToast from '../../../../shared/lib/toast/error.toast'
import successToast from '../../../../shared/lib/toast/success.toast'

function ResetPasswordFormProvider({ children, email, token }: PropsWithChildren & { email: string, token: string }) {

    const router = useRouter()
    
    const onSubmit = async (data: ResetPasswordFormType) => {
        try {
            if(!email || !token) throw new Error('Invalid reset password link') 
            const res = await resetPassword({
                email: email,
                token: token,
                password: data.password
            })
            if(!res.success) throw new Error(res.message)
            successToast("Password reset successfully")
            router.push(PAGE_ROUTES.login)
            router.refresh()

        } catch(e) {
            const error = e as Error
            errorToast(error.message)

        }
    }

    return (
        <BaseFormProvider
            onSubmit={onSubmit}
            schema={resetPasswordFormSchema}
        >
            {children}
        </BaseFormProvider>
    )
}

export default ResetPasswordFormProvider